"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REPORT_RULE_CODES = exports.REPORT_RULE_PLACEHOLDERS = exports.REPORT_RULE_KEYS = void 0;
// The rule keys of each measure's report table, in evaluation order (CR-002-SPEC §6.1–§6.5). The
// conditions are code (J-083 evaluates them in this order, the first match wins); the wording of each
// rule — status label, consolidated label, action and gap flag — is configuration, in
// `config/measures/<year>.yaml` `report.rules` (CR-002 CR2-064, CR2-111, D-1114).
exports.REPORT_RULE_KEYS = {
    "134": [
        "excluded",
        "exception",
        "met_negative",
        "met_positive_fu",
        "met",
        "positive_no_fu",
        "no_screening",
        "no_data",
    ],
    "001": [
        "excluded",
        "exception",
        "poor_gt9",
        "not_done",
        "poor",
        "controlled_8_9",
        "controlled",
        "no_data",
    ],
    "236": ["excluded", "exception", "controlled", "no_bp", "uncontrolled", "no_data"],
    "112": ["excluded", "exception", "screened", "no_screening", "no_data"],
    "113": ["excluded", "exception", "screened", "no_screening", "no_data"],
};
/** The one placeholder a rule's label or action may hold: the exclusion reason (CR-002 §6, CR2-065). */
exports.REPORT_RULE_PLACEHOLDERS = ["reason"];
/**
 * The quality codes a rule's condition names (CR-002-SPEC §6.1–§6.5): `poor_gt9` is MET with M1211, and
 * so on. J-083's conditions read them; the synthetic generator writes them on the rows those rules
 * describe (CR-002 CR2-085), so the demo's report rows land where the rules put them.
 */
exports.REPORT_RULE_CODES = {
    "001": { poor_gt9: "M1211", not_done: "M1212", controlled_8_9: "M1373" },
    "134": { met_negative: "G8510", met_positive_fu: "G8431", positive_no_fu: "G8511" },
    "236": { no_bp: "G8756" },
};
//# sourceMappingURL=report-rules.js.map